// extracted by mini-css-extract-plugin
export default {"image__container":"OptImg_image__container__u+ZLW","image__container--inner":"OptImg_image__container--inner__GqR1J","image__image":"OptImg_image__image__FCitS"};